import React from "react";
import axios from "axios";
import "./style.css";
import helper from "../helper";
import { SpinnerCircularFixed } from "spinners-react";
import ReactExport from "react-data-export";

class Body extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      channelInfo: this.props.channelInfo,
      selectedChannel: "",
      currentChannelname: "No channel selected",
      selectedWeek: helper.getDaysOfWeek(helper.getCurrentWeek()),
      weekValue: helper.getCurrentWeek(),
      partner: "SportRadar",
      height: "1200px",
      loading: false,
    };
  }

  onChannelSelect = (e) => {
    let selectedChannel = "";
    if (e.target.value !== "channelname") {
      if (JSON.parse(e.target.value).content) {
        selectedChannel = JSON.parse(e.target.value).content;
        this.setState(
          { selectedChannel, partner: "VEVO", height: "1200px" },
          () => {
            this.getEpg(selectedChannel, this.state.selectedWeek, "VEVO");
          }
        );
      } else if (JSON.parse(e.target.value).endpoint) {
        selectedChannel = JSON.parse(e.target.value).endpoint;
        this.setState(
          { selectedChannel, partner: "SportRadar", height: "1200px" },
          () => {
            this.getEpg(selectedChannel, this.state.selectedWeek, "SportRadar");
          }
        );
      }
    } else {
      this.setState({ currentEpg: "", selectedChannel: "" });
    }

    this.setState({
      currentChannelname: e.target.options[e.target.selectedIndex].text,
    });
  };

  onWeekSelect = (e) => {
    const selectedWeek = helper.getDaysOfWeek(e.target.value);
    if (this.state.selectedChannel !== "") {
      if (this.state.partner === "VEVO") {
        this.setState(
          { selectedWeek, weekValue: e.target.value, height: "1200px" },
          () => {
            this.getEpg(this.state.selectedChannel, selectedWeek, "VEVO");
          }
        );
      } else if (this.state.partner === "SportRadar") {
        this.setState(
          { selectedWeek, weekValue: e.target.value, height: "1200px" },
          () => {
            this.getEpg(this.state.selectedChannel, selectedWeek, "SportRadar");
          }
        );
      }
    } else {
      this.setState({ selectedWeek, weekValue: e.target.value });
    }
  };

  getEpg = (endpoint, week, partner) => {
    let assets = [];
    let i = 0;

    this.setState({ loading: true });

    let first = true;
    if (partner === "SportRadar") {
      for (let day in week) {
        axios
          .get(
            `${endpoint}&startDay=${week[day].start
              .toISOString()
              .slice(0, -5)}+00:00&endDay=${week[day].end
              .toISOString()
              .slice(0, -5)}+00:00`
          )
          .then((res) => {
            let currentDay = {};

            for (let asset in res.data.assets) {
              const startDate = new Date(res.data.assets[asset].start);
              const startHours = helper.getFormattedTimeHelper(
                startDate.getHours()
              );
              const startMinutes = helper.getFormattedTimeHelper(
                startDate.getMinutes()
              );

              const endDate = new Date(res.data.assets[asset].end);
              const endHours = helper.getFormattedTimeHelper(
                endDate.getHours()
              );
              const endMinutes = helper.getFormattedTimeHelper(
                endDate.getMinutes()
              );

              currentDay[res.data.assets[asset].id] = {
                title:
                  res.data.assets[asset].content.editorial.translations.en
                    .title,
                start: res.data.assets[asset].start,
                end: res.data.assets[asset].end,
                duration: helper.getDuration(
                  `${startHours}:${startMinutes}`,
                  `${endHours}:${endMinutes}`,
                  first
                ),
              };
              first = false;
            }
            first = true;
            assets[day] = currentDay;
            if (i === 6) {
              this.setState({ currentEpg: assets, loading: false });
            }
            i++;
          })
          .catch((error) => console.error(error));
      }
    } else if (partner === "VEVO") {
      let day = {};

      axios
        .get(endpoint)
        .then((res) => {
          let index = 0;

          for (let asset in res.data.assets) {
            const startDate = new Date(res.data.assets[asset].start);
            const startHours = helper.getFormattedTimeHelper(
              startDate.getHours()
            );
            const startMinutes = helper.getFormattedTimeHelper(
              startDate.getMinutes()
            );

            const endDate = new Date(res.data.assets[asset].end);
            const endHours = helper.getFormattedTimeHelper(endDate.getHours());
            const endMinutes = helper.getFormattedTimeHelper(
              endDate.getMinutes()
            );

            day[index] = {
              title: res.data.assets[asset].title,
              start: res.data.assets[asset].start,
              end: res.data.assets[asset].end,
              duration: helper.getDuration(
                `${startHours}:${startMinutes}`,
                `${endHours}:${endMinutes}`
              ),
            };
            index++;
          }
          assets[0] = day;
          this.setState({ currentEpg: assets, loading: false });
        })
        .catch((error) => console.error(error));
    }
  };

  onPlusButtonClicked = () => {
    const { height, partner } = this.state;
    let newHeight;
    if (partner === "VEVO") {
      newHeight = `${parseInt(height.slice(0, height.length - 2)) + 2000}px`;
    } else {
      newHeight = `${parseInt(height.slice(0, height.length - 2)) + 250}px`;
    }
    this.setState({ height: newHeight });
  };

  onMinusButtonClicked = () => {
    const { height, partner } = this.state;
    let newHeight;
    if (partner === "VEVO") {
      newHeight = `${parseInt(height.slice(0, height.length - 2)) - 2000}px`;
    } else {
      newHeight = `${parseInt(height.slice(0, height.length - 2)) - 250}px`;
    }
    this.setState({ height: newHeight });
  };

  renderBody() {
    const { currentEpg, selectedWeek, height, partner } = this.state;
    if (!currentEpg) return null;

    return (
      <div id="weekContainer" className="weekContainer">
        <div className="timelineContainer" style={{ height: height }}>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2) / 12 - 20) / 2 }}
          >
            8:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            10:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            12:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            14:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            16:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            18:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            20:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            22:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            0:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            2:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            4:00
          </div>
          <div
            className="timelineTime"
            style={{ marginTop: parseInt(height.slice(0, -2)) / 12 - 20 }}
          >
            6:00
          </div>
        </div>
        {Object.keys(currentEpg).map((day) => {
          if (JSON.stringify(currentEpg[day]).length === 2) {
            return (
              <div className="dayContainer" key={day}>
                <div className="noData">no data</div>
              </div>
            );
          } else {
            return (
              <div
                className="dayContainer"
                key={day}
                id={`dayContainer${day}`}
                style={{ height: height }}
              >
                {partner === "VEVO" ? (
                  ""
                ) : (
                  <div className="date">
                    {helper.getFormattedWeekDate(selectedWeek[day].start, day)}
                  </div>
                )}
                {Object.keys(currentEpg[day]).map((show) => {
                  return (
                    <div
                      className="showContainer"
                      style={helper.getDurationHeight(
                        currentEpg[day][show].duration
                      )}
                      key={show}
                    >
                      <div className="showInnerContainer">
                        <div className="showDuration">
                          {helper.getFormattedStartEnd(
                            currentEpg[day][show].start,
                            currentEpg[day][show].end
                          )}
                        </div>
                        <div className="showTitle">
                          {currentEpg[day][show].title}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          }
        })}
      </div>
    );
  }

  onExport = () => {
    if (this.state.currentChannelname !== "No channel selected") {
      const headerPrint = document.getElementById("headerPrint");
      const main = document.getElementById("main");
      main.style.width = "97%";
      main.style.margin = "auto";
      headerPrint.style.display = "flex";
      document.title = `rlaxxTV_EPGOverview${helper.getChannelNameWithoutWhitespace(
        this.state.currentChannelname
      )}${helper.getWeekPDF(this.state.selectedWeek)}`;
      window.print();
      document.title = "rlaxx TV EPG Overview";
      headerPrint.style.display = "none";
      main.style.width = "100%";
    } else {
      alert("Please select a channel first!");
    }
  };

  getExcelData = () => {
    const { currentEpg } = this.state;

    //convert array of objects to array of array
    const days = [];
    let showsPerDay = [];
    if (currentEpg) {
      for (let i = 0; i < currentEpg.length; i++) {
        for (const show in currentEpg[i]) {
          let test =
            helper.getFormattedStartEnd(
              currentEpg[i][show].start,
              currentEpg[i][show].end
            ) +
            "\n" +
            currentEpg[i][show].title;
          showsPerDay.push(test);
        }

        //delete double entry
        showsPerDay.pop();

        days.push(showsPerDay);
        showsPerDay = [];
      }

      // convert the array so it will fit the react-data-export form
      let isDataAvailable = true;
      const excelArray = [];

      let counter = 0;
      while (isDataAvailable) {
        isDataAvailable = false;
        const row = {};
        for (let i = 0; i < days.length; i++) {
          const day = days[i];
          const show = day[counter];

          if (show) {
            isDataAvailable = true;
            row[i] = show;
          } else {
            row[i] = "";
          }
        }

        if (isDataAvailable === true) {
          excelArray.push(row);
          counter += 1;
        }
      }

      let realArray = [];

      for (let i = 0; i < excelArray.length; i++) {
        realArray.push([
          {
            value: excelArray[i][0],
            style: {
              font: { sz: "10", name: "Ubuntu" },
              alignment: { wrapText: true },
            },
          },
          {
            value: excelArray[i][1],
            style: {
              font: { sz: "10", name: "Ubuntu" },
              alignment: { wrapText: true },
            },
          },
          {
            value: excelArray[i][2],
            style: {
              font: { sz: "10", name: "Ubuntu" },
              alignment: { wrapText: true },
            },
          },
          {
            value: excelArray[i][3],
            style: {
              font: { sz: "10", name: "Ubuntu" },
              alignment: { wrapText: true },
            },
          },
          {
            value: excelArray[i][4],
            style: {
              font: { sz: "10", name: "Ubuntu" },
              alignment: { wrapText: true },
            },
          },
          {
            value: excelArray[i][5],
            style: {
              font: { sz: "10", name: "Ubuntu" },
              alignment: { wrapText: true },
            },
          },
          {
            value: excelArray[i][6],
            style: {
              font: { sz: "10", name: "Ubuntu" },
              alignment: { wrapText: true },
            },
          },
        ]);
      }

      return realArray;
    }
  };

  getExcelDataSet = () => {
    const { selectedWeek } = this.state;
    const excelData = this.getExcelData();
    return [
      {
        columns: [
          {
            title: helper.getFormattedWeekDate(selectedWeek[0].start, 0),
            width: { wch: 50 },
            style: { font: { sz: "14", bold: true, name: "Ubuntu" } },
          },
          {
            title: helper.getFormattedWeekDate(selectedWeek[1].start, 1),
            width: { wch: 50 },
            style: { font: { sz: "14", bold: true, name: "Ubuntu" } },
          },
          {
            title: helper.getFormattedWeekDate(selectedWeek[2].start, 2),
            width: { wch: 50 },
            style: { font: { sz: "14", bold: true, name: "Ubuntu" } },
          },
          {
            title: helper.getFormattedWeekDate(selectedWeek[3].start, 3),
            width: { wch: 50 },
            style: { font: { sz: "14", bold: true, name: "Ubuntu" } },
          },
          {
            title: helper.getFormattedWeekDate(selectedWeek[4].start, 4),
            width: { wch: 50 },
            style: { font: { sz: "14", bold: true, name: "Ubuntu" } },
          },
          {
            title: helper.getFormattedWeekDate(selectedWeek[5].start, 5),
            width: { wch: 50 },
            style: { font: { sz: "14", bold: true, name: "Ubuntu" } },
          },
          {
            title: helper.getFormattedWeekDate(selectedWeek[6].start, 6),
            width: { wch: 50 },
            style: { font: { sz: "14", bold: true, name: "Ubuntu" } },
          },
        ],
        data: excelData,
      },
    ];
  };

  renderContent() {
    const {
      channelInfo,
      weekValue,
      loading,
      selectedWeek,
      currentChannelname,
    } = this.state;

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

    return (
      <div>
        <div id="headerPrint" className="headerPrint print">
          <h1 className="rlaxxTVHeadline">rlaxx TV EPG Overview</h1>
          <div className="headerSecondLineContainerPrint">
            <h3 className="selectedChannelPrint">{currentChannelname}</h3>
            <p className="selectedWeekPrint">
              {helper.getWeekStartEnd(selectedWeek)}
            </p>
          </div>
        </div>
        <div className="headerContainer noPrint" id="headerContainer">
          <h1 className="rlaxxTVHeadline" id="rlaxxTVHeadline">
            rlaxx TV EPG Overview
          </h1>
          <div
            id="headerSecondLineContainer"
            className="headerSecondLineContainer"
          >
            <select
              name="Channelname"
              id="channelnameSelect"
              className="channelnameSelect"
              onChange={this.onChannelSelect}
            >
              <option key="channelname" value="channelname">
                Channelname
              </option>
              {channelInfo.map((channel) => {
                return (
                  <option
                    key={channel.id}
                    className="channelSelectOption"
                    value={JSON.stringify(channel.epg)}
                  >
                    {channel.title}
                  </option>
                );
              })}
            </select>
            <input
              lang="en-us"
              type="week"
              id="dateSelect"
              className="dateSelect"
              onChange={this.onWeekSelect}
              value={weekValue}
            />
            <p id="elementHeightText" className="elementHeightText">
              Element height
            </p>
            <button
              id="elementHeightPlusButton"
              className="elementHeightPlusButton"
              onClick={this.onPlusButtonClicked}
            >
              +
            </button>
            <button
              id="elementHeightMinusButton"
              className="elementHeightMinusButton"
              onClick={this.onMinusButtonClicked}
            >
              -
            </button>
            <button
              id="exportButton"
              className="exportButton"
              onClick={this.onExport}
            >
              Export PDF
            </button>
            <ExcelFile
              element={<button className="exportButton">Export Excel</button>}
              filename={`rlaxxTV_EPGOverview${helper.getChannelNameWithoutWhitespace(
                this.state.currentChannelname
              )}${helper.getWeekPDF(this.state.selectedWeek)}`}
            >
              <ExcelSheet
                dataSet={this.getExcelDataSet()}
                name={helper.getWeekStartEnd(selectedWeek)}
              />
            </ExcelFile>
          </div>
        </div>
        {!loading ? (
          <div>{this.renderBody()}</div>
        ) : (
          <SpinnerCircularFixed
            style={{
              color: "#0a2244",
              position: "relative",
              marginTop: "15%",
              marginLeft: "50%",
            }}
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div id="main" style={{ height: window.innerHeight }}>
        {this.renderContent()}
      </div>
    );
  }
}

export default Body;
